export { default } from './SmallPropertyCard';
